<template lang="pug">
v-select( 
  :value="value"
  @input="$emit('input', $event)"
  :multiple="multiple"
  :clearable="clearable"
  hide-details
  :items="items"
  :loading="loading"
  :disabled="disabled"
  :label="label"
  :item-text="itemText",
  :item-value="itemValue"
  :menu-props="{contentClass: 'menu-with-scroll-visible'}"
  small
  @mouseup="closeSelectIfOpen($refs.select, {enabled: closeOnInputClick})"
  ref="select"
)
  template(v-slot:append v-if="hasValue")
    v-icon(color="primary") mdi-check-circle
  template(v-slot:prepend-item v-if="showCloseMenuBtn")
    select-close-btn(@click.native="closeSelect($refs.select)")
</template>

<script>
import AutocompleteMixin from "@/app/admin/mixins/autocomplete.mixin"
export default {
  mixins: [AutocompleteMixin],
  props: {
    items: {
      type: Array,
      required: true
    },
    value: {
      required: true
    },
    field: {
      type: String
    },
    label: String,
    itemText: String,
    itemValue: String,
    multiple: Boolean,
    clearable: Boolean,
    loading: Boolean,
    disabled: Boolean,
    showCloseMenuBtn: Boolean,
    closeOnInputClick: Boolean
  },

  computed: {
    hasValue() {
      if(!this.multiple && this.value) return true
      if(this.multiple && this.value.length) return true
      return false
    }
  },

  components: {
    selectCloseBtn: () => import('@/app/admin/components/SelectCloseBtn.vue'),
  }
}
</script>